const Linter = require('./linter');

module.exports = {
  Linter
};